import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'

export default function ConfirmDeselectTcModal({ onCancel, onConfirm, tcs }) {
  const { t } = useTranslation()

  return (
    <div className="yes-no-prompt">
      <div className="yes-no-prompt_content">
        <h1>{t('Recommendations.confirmDeselectTc.title')}</h1>
        <p>{t('Recommendations.confirmDeselectTc.body', { names: tcs.join(', ') })}</p>
      </div>

      <div className="yes-no-prompt_footer">
        <TransparentBgButton text={t('Recommendations.confirmDeselectTc.btnCancel')} onClick={onCancel} color="navy" />

        <SecondaryButton
          className="bt"
          text={t('Recommendations.confirmDeselectTc.btnConfirm')}
          fullWidth={false}
          onClick={onConfirm}
        />
      </div>
    </div>
  )
}

ConfirmDeselectTcModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
